export const buttonStyle = {
    padding: " 6px 24px",
    borderRadius: "8px",
    fontSize: "large",
    fontWeight: "bold",
    backgroundColor: "#2a2aa8",
    marginBottom: "auto",
    marginTop: "auto"
}

export const iconStyle = {
    fontSize: 20,
    verticalAlign: "sub",
    marginRight: "8px"
}

export const icons = {
    verticalAlign: "middle",
    fontSize: "30px",
    marginLeft: "5px",
    color: "#565a5fe0",
    cursor: "pointer"
}

export const cardHeader = {
    fontSize: "18px",
    fontWeight: 700,
    fontFamily: "'DM Sans', sans-serif",
    marginBottom: "15px",
    color: "#1b254b"
}

export const cardStyle = {
    marginTop: "12px",
    padding: "20px",
    borderRadius: "20px",
    border: "0px",
    boxShadow: "0 1px 4px rgba(133, 146, 173, .2)"
}

export const butttonWithIcon = {
    display: "flex",
    width: "60px",
    height: "45px",
    backgroundColor: "#a1a3ff59",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "25px",
    marginLeft: "10px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",

    "&:hover": {
        backgroundColor: "#a1a3ffa3",
    }

}

export const secondary_icon = { fontSize: 30, verticalAlign: "sub", color: "#696cff" }

export const modalstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "75%",
    borderRadius: "32px",
    border: 'none',
    bgcolor: '#f8fafd',
    boxShadow: 24,
    p: 4,
};

export const textStyle = { color: "#6c6c6c", marginLeft: "5px", fontWeight: "normal" }
export const headerStyle = { width: "fit-content", color: "#1f6589", borderRadius: "16px", padding: "4px 16px", backgroundColor: "aliceblue", marginBottom: "4px", fontSize: "17px", fontWeight: "bold", fontFamily: "DM Sans, sans-serif", }

export const subHeaderStyle = { fontSize: "15px", fontWeight: "bold", fontFamily: "DM Sans, sans-serif", color: "#05265ae0", display: "flex", alignContent: "center" }
export const card_icon = { marginLeft: "5px", fontSize: "23px" }